import type { DragEvent, KeyboardEvent } from "react";
import { Badge } from "@/components/ui";
import { TIER_BADGE_VARIANT, TIER_LABELS, type OutreachBoardItem } from "@/api/types/outreach";
import { daysSinceLabel } from "./format";

interface OutreachCardProps {
  item: OutreachBoardItem;
  onOpen: () => void;
  onDragStart: (e: DragEvent<HTMLDivElement>) => void;
}

export function OutreachCard({ item, onOpen, onDragStart }: OutreachCardProps) {
  function handleKeyDown(e: KeyboardEvent<HTMLDivElement>) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onOpen();
    }
  }

  return (
    <div
      role="button"
      tabIndex={0}
      draggable
      data-outreach-id={item.id}
      onDragStart={onDragStart}
      onClick={onOpen}
      onKeyDown={handleKeyDown}
      className="cursor-grab rounded-lg border border-border bg-bg-card p-3 shadow-sm transition-colors hover:border-copper/50 active:cursor-grabbing"
    >
      <div className="flex items-start justify-between gap-2">
        <p className="truncate text-sm font-medium text-text-primary">
          {item.contact_name ?? "Unnamed contact"}
        </p>
        {!item.verified && (
          <Badge variant="warning" size="sm" data-testid={`unverified-chip-${item.id}`}>
            ⚠ verify
          </Badge>
        )}
      </div>

      <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
        <Badge variant={TIER_BADGE_VARIANT[item.tier]} size="sm">
          {TIER_LABELS[item.tier]}
        </Badge>
      </div>

      <p className="mt-2 text-xs text-text-secondary">{daysSinceLabel(item.days_since_touch)}</p>
    </div>
  );
}
